module.exports = __webpack_public_path__ + "static/media/IPublico2.14b22659.svg";